import { render, staticRenderFns } from "./unitVideo.vue?vue&type=template&id=6801e1f0&scoped=true&"
import script from "./unitVideo.vue?vue&type=script&lang=js&"
export * from "./unitVideo.vue?vue&type=script&lang=js&"
import style0 from "./unitVideo.vue?vue&type=style&index=0&id=6801e1f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6801e1f0",
  null
  
)

export default component.exports